import { Actor, HttpAgent } from '@dfinity/agent';
import { AuthClient } from '@dfinity/auth-client';
import { idlFactory as gameIdl, canisterId as gameId } from 'dfx-generated/game';
export const httpAgent = async () => {
    const authClient = await AuthClient.create();
    const identity = await authClient.getIdentity();
    const agent = new HttpAgent({ identity });
    const icdrive = Actor.createActor(gameIdl, { agent, canisterId: gameId });
    return icdrive;
};
